import React from 'react';
import { Outlet, NavLink, useLocation } from 'react-router-dom';
import { Home, Layers, Calendar, Settings } from 'lucide-react';
import { cn } from '@/lib/utils';

export function Layout() {
    const location = useLocation();
    
    const navItems = [
        { path: '/', icon: Home, label: 'Today' },
        { path: '/stacks', icon: Layers, label: 'Stacks' },
        { path: '/history', icon: Calendar, label: 'History' },
        { path: '/settings', icon: Settings, label: 'Settings' },
    ];
    
    return (
        <div className="min-h-screen flex flex-col bg-background">
            <main className="flex-1 pb-16">
                <Outlet />
            </main>
            
            {/* Bottom navigation */}
            <nav className="fixed bottom-0 left-0 right-0 bg-card border-t border-border z-50">
                <div className="max-w-lg mx-auto">
                    <div className="flex items-center justify-around h-14">
                        {navItems.map(({ path, icon: Icon, label }) => {
                            const isActive = path === '/' 
                                ? location.pathname === '/' 
                                : location.pathname.startsWith(path);
                            
                            return (
                                <NavLink
                                    key={path}
                                    to={path}
                                    className={cn(
                                        "flex flex-col items-center justify-center gap-0.5 px-4 py-1 transition-colors",
                                        isActive 
                                            ? "text-primary" 
                                            : "text-muted-foreground hover:text-foreground"
                                    )}
                                >
                                    <Icon className={cn(
                                        "w-5 h-5",
                                        isActive && "stroke-[2.5]"
                                    )} />
                                    <span className={cn(
                                        "text-[10px]",
                                        isActive ? "font-semibold" : "font-medium"
                                    )}>
                                        {label}
                                    </span>
                                </NavLink>
                            );
                        })}
                    </div>
                </div>
            </nav>
        </div>
    );
}
